import { h } from 'preact';
import useFormStore from '../../store/useFormStore';

/**
 * Block component for displaying user information in review format
 * Gets data directly from the store
 */
export default function UserInformationReviewBlock() {
  const userInfo = useFormStore((state) => state.userFormInformation);
  const needsPortableEquipment = useFormStore((state) => state.needsPortableEquipment);

  if (!userInfo) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      {/* Name */}
      {(userInfo.firstName || userInfo.lastName) && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">Name:</span>
          <span>{userInfo.firstName} {userInfo.lastName}</span>
        </div>
      )}

      {/* Street Address */}
      {userInfo.streetAddress && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">Address:</span>
          <span>{userInfo.streetAddress}</span>
        </div>
      )}

      {/* Unit/Apartment */}
      {userInfo.unit && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">Unit No / Apartment:</span>
          <span>{userInfo.unit}</span>
        </div>
      )}

      {/* City */}
      {userInfo.city && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">City:</span>
          <span>{userInfo.city}</span>
        </div>
      )}

      {/* State */}
      {userInfo.state && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">State:</span>
          <span>{userInfo.state}</span>
        </div>
      )}

      {/* Postal Code */}
      {userInfo.postalCode && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">Zip Code:</span>
          <span>{userInfo.postalCode}</span>
        </div>
      )}

      {/* Portable Equipment */}
      {needsPortableEquipment && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">Tell Us About Your Home:</span>
          <span>I have no parking and/or am on a 3rd floor or higher</span>
        </div>
      )}

      {/* Email */}
      {userInfo.email && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">Email:</span>
          <span>{userInfo.email}</span>
        </div>
      )}

      {/* Email Signup */}
      {userInfo.signUpForEmails !== undefined && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">Sign up for our newsletter:</span>
          <span>{userInfo.signUpForEmails ? "Yes" : "No"}</span>
        </div>
      )}

      {/* Phone */}
      {userInfo.phoneNumber && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">Phone:</span>
          <span>{userInfo.phoneNumber}</span>
        </div>
      )}

      {/* SMS Signup */}
      {userInfo.signUpForTexts !== undefined && (
        <div className="border-b border-b-gray-300 pb-4 grid grid-cols-2 gap-1">
          <span className="font-medium">Sign up for texts:</span>
          <span>{userInfo.signUpForTexts ? "Yes" : "No"}</span>
        </div>
      )}
    </div>
  );
}
